import { propAccessor } from '@hc-frontend/utils'
import getAndValidatePeriod from 'utils/pivot/plan/getAndValidateDuration'
import getExtendDuration from 'utils/pivot/plan/getExtendDuration'
import getPeriodId from 'utils/pivot/plan/getPeriodId'
import getValidDuration from 'utils/pivot/plan/getValidDuration'
import getValidPeriodKey from 'utils/pivot/plan/period/getValidPeriodKey'
import parsePlanPeriod from 'utils/pivot/plan/period/parsePlanPeriod'
import store from 'utils/store/withMiddleware'
import { enableMultiCarrierPlans } from 'utils/experiments'

const getOptionLabel = ({ period, policies, plan, hcStorage, extendedDuration }) => {
  const monthDuration = propAccessor<number>(plan, [
    'durations',
    period,
    policies,
    'policyMonthsDuration'
  ])
  if (monthDuration != null && enableMultiCarrierPlans()) {
    return `${monthDuration} months`
  }

  const customLabel = getPeriodId(policies, period, {
    stateAcronym: hcStorage.location.state_acronym,
    plan,
    omitSinglePolicy: true,
    extendedDuration: extendedDuration || period
  })
  return `${customLabel} days`
}

function getPeriodOptions({ plan, filterOptions, filters }) {
  // duration
  const { hcStorage, defaultPeriod } = store.getState()

  const period = String(filters.period || defaultPeriod)

  const periodOpts = filterOptions.period.values.reduce((result, current) => {
    const { period, policies } = parsePlanPeriod(current)

    const extendedDuration = getExtendDuration(plan, period)

    result[current] = getOptionLabel({
      period,
      policies,
      plan,
      hcStorage,
      extendedDuration
    })

    return result
  }, {})

  const validatedPlanDurations = getAndValidatePeriod(plan, period)

  const duration: Duration = getValidDuration(validatedPlanDurations, filters.policies)
  const validatedPlanPeriod = duration.policyDuration
  const planPolicies = duration.recurrence

  const planPeriodValue = parsePlanPeriod(String(validatedPlanPeriod))

  const validatedPeriodKey = getValidPeriodKey(plan, planPeriodValue.period)

  const values = period.includes(validatedPeriodKey) ? period : validatedPeriodKey

  let keyValue = `${planPolicies > 1 ? `${planPolicies}x` : ''}${values}`

  if (
    hcStorage.location.state_acronym === 'ND' &&
    planPolicies > 1 &&
    plan.planTypeKey.includes('epic')
  ) {
    keyValue = '360'
  }

  return { options: periodOpts, values: [keyValue] }
}

export default getPeriodOptions
